// Compact colour-key legend for operations active on the current roster window.
// Renders nothing when there are no operations overlapping the window.
import { ClipboardList } from "lucide-react";

const OperationsLegend = ({ operations, rosterStart, rosterEnd, onManageClick }) => {
  if (!operations || operations.length === 0) return null;

  // Only show ops that actually touch the roster window
  const inWindow = operations.filter((op) =>
    (op.dates || []).some((d) => d >= rosterStart && d <= rosterEnd),
  );
  if (inWindow.length === 0) return null;

  return (
    <div className="bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 p-4" data-testid="operations-legend">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-xs uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400 flex items-center gap-2">
          <ClipboardList className="w-3.5 h-3.5" />
          Operations on this roster ({inWindow.length})
        </h3>
        {onManageClick && (
          <button
            onClick={onManageClick}
            className="text-xs text-[#002FA7] dark:text-blue-400 hover:underline"
            data-testid="operations-manage-link"
          >
            Manage operations →
          </button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {inWindow.map((op) => (
          <span
            key={op.operation_id}
            className="inline-flex items-center gap-2 px-2.5 py-1 text-xs rounded border"
            style={{
              backgroundColor: op.color + "1A",
              borderColor: op.color + "55",
              color: "var(--legend-text, currentColor)",
            }}
            title={`${op.name} — ${op.staff_required} required, ${op.is_hard ? "hard" : "soft"} rule, ${op.dates.length} day${op.dates.length === 1 ? "" : "s"}`}
            data-testid={`operations-legend-${op.operation_id}`}
          >
            <span className="w-3 h-3 rounded-sm" style={{ backgroundColor: op.color }} />
            <span className="font-medium text-zinc-900 dark:text-zinc-100">{op.name}</span>
            <span className="text-zinc-500 dark:text-zinc-400">×{op.staff_required}</span>
            <span
              className={`text-[9px] uppercase tracking-wide px-1 rounded ${
                op.is_hard
                  ? "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300"
                  : "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300"
              }`}
            >
              {op.is_hard ? "Hard" : "Soft"}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default OperationsLegend;
